import { type ObjectValuesUnionType } from '../../../utils/typing';

export const BoomBasketErrorCodes = {
  E_OP_NOT_RUNNING: 58000,
  E_USER_NOT_IN: 58001,
  E_FREEBET_FORBIDDEN: 58002,
  E_SYSTEM_FORBIDDEN: 58003,
  E_MATCH_PENDING: 58004,
  E_START_DATE_OVER_48: 58005,
  E_BETSLIP_NOT_ELIGIBLE: 58006,
  E_INTERNAL_ERROR: 58007,
  E_START_DATE_OVER_OPE: 58008,
  E_WRONG_ADVENTURE: 58009,
  E_USER_EXCLUDED: 58010,
  E_ALREADY_PAID: 58011,
  E_PAYMENT_ERROR: 58012,
  E_ALREADY_REGISTERED: 58013,
  E_RMJ_30: 58014,
  E_SELF_EXCLUDED: 58015,
  E_LICENSE_NOT_FOUND: 58016,
  E_STEP_NOTIFICATION: 58017,
  E_STEP_NOT_FOUND: 58018,
  E_BOOM_NOT_FOUND: 58019,
  E_USER_STATE_NOT_FOUND: 58020,
  E_STEP_PENDING: 58021,
};
export type BoomBasketErrorCode = ObjectValuesUnionType<typeof BoomBasketErrorCodes>;
